import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { createI18n } from 'vue-i18n'

import enMessages from './locales/en.json';
import jaMessages from './locales/ja.json';
import zhMessages from './locales/zh.json'; // Added for Chinese locale

const messages = {
  en: enMessages,
  ja: jaMessages,
  zh: zhMessages, // Added for Chinese locale
}

const i18n = createI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
})

import UserLogin from './components/Login.vue'
import AppDashboard from './components/AppDashboard.vue'
import CompetitorInventoryStatus from './components/CompetitorInventoryStatus.vue'
import ProductList from './components/ProductList.vue'
import ProductDetails from './components/ProductDetail.vue'
import ProductCompare from './components/ProductCompare.vue'
// import AppAlerts from './components/AppAlerts.vue'
import AppReviewAnalytics from './components/AppReviewAnalytics.vue'

import ScraperManagement from './components/ScraperManagement.vue'
import Health from './components/Health.vue'
import IntelligenceAnalysisView from './views/IntelligenceAnalysisView.vue';
import { isAuthenticated, authInitialized, initAuth, setRouter } from './utils/auth'; // Removed authAxios

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/styles.css';

const routes = [
  { path: '/', redirect: '/dashboard' },
  { path: '/login', component: UserLogin },
  { path: '/health', component: Health },
  { path: '/dashboard', component: AppDashboard, meta: { requiresAuth: true } },
  { path: '/competitor-inventory-status', component: CompetitorInventoryStatus, meta: { requiresAuth: true } },
  { path: '/products', component: ProductList, meta: { requiresAuth: true } },
  { path: '/products/:id', component: ProductDetails, props: true, meta: { requiresAuth: true } },
  { path: '/compare', component: ProductCompare, meta: { requiresAuth: true } },
  // { path: '/alerts', component: AppAlerts, meta: { requiresAuth: true } },
  { path: '/review-analytics', component: AppReviewAnalytics, meta: { requiresAuth: true } },
  { path: '/scraper', component: ScraperManagement, meta: { requiresAuth: true } },
  { path: '/intelligence-analysis', component: IntelligenceAnalysisView, meta: { requiresAuth: true } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  console.log(`🚦 Route guard: ${from.path} -> ${to.path}`);
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  console.log('🔒 Requires auth:', requiresAuth);

  // Wait for auth initialization if not already done
  if (!authInitialized.value) {
    console.log('⏳ Waiting for auth initialization...');
    await initAuth();
  }

  console.log('👤 Is authenticated:', isAuthenticated.value);

  if (requiresAuth) {
    // Check if user is authenticated
    if (!isAuthenticated.value) {
      // If not authenticated, redirect to login
      console.log('🚫 Redirecting to login');
      next('/login');
    } else {
      // If authenticated, allow access
      console.log('✅ Access granted');
      next();
    }
  } else {
    // If route doesn't require auth, allow access
    console.log('🔓 Public route, access granted');
    next();
  }
});

// Set router instance for auth.js
setRouter(router);

// Export the router instance for auth.js
export default router;

createApp(App).use(i18n).use(router).mount('#app');